'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsModal = exports.CmsModalUnwrapped = exports.mapStateToProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _cmsDataToModuleArray = require('components/CmsPage/cmsDataToModuleArray');

var _CmsModules = require('containers/CmsPage/CmsModules');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _decorator = require('helpers/decorator');

var _device = require('redux/modules/device');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
  var modules = _ref.modules,
      backgroundImage = _ref.backgroundImage;
  return {
    bgDesktop: backgroundImage && backgroundImage.image,
    bgMobile: backgroundImage && backgroundImage.imageMobile,
    isMobile: (0, _device.selectIsMobile)(state),
    modules: (0, _cmsDataToModuleArray.cmsDataToModuleArray)(state, { modules: modules })
  };
};

var CmsModalUnwrapped = exports.CmsModalUnwrapped = function CmsModalUnwrapped(_ref2) {
  var bgDesktop = _ref2.bgDesktop,
      bgMobile = _ref2.bgMobile,
      isMobile = _ref2.isMobile,
      modules = _ref2.modules;

  var bgImg = isMobile ? bgMobile : bgDesktop;

  return _react2.default.createElement(
    'div',
    { style: bgImg && { backgroundImage: 'url(' + bgImg + ')' } },
    _react2.default.createElement(
      'div',
      { className: 'modal__body' },
      _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
    )
  );
};

CmsModalUnwrapped.propTypes = {
  bgDesktop: _propTypes2.default.string,
  bgMobile: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool.isRequired,
  modules: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    cmsModuleId: _propTypes2.default.string.isRequired
  }).isRequired).isRequired
};

var CmsModal = exports.CmsModal = (0, _decorator.decorateWith)((0, _Modal2.default)(), (0, _reactRedux.connect)(mapStateToProps))(CmsModalUnwrapped);